<template>
  <!-- 考试分类 -->
  <div class="template-list main-container">
    <div class="main-panel">
      <div class="search-box gauge_20">
        <div class="input-item">
          <span class="label">考试分类</span>
          <Input v-model="search.name" clearable placeholder="请输入" />
        </div>
        <div class="btn-item">
          <Button type="primary" @click="searchAjax(1)">查询</Button>
          <Button type="warning" @click="openTemplateEdit({})" v-if="$units.pointAction('content_5_1_1')">新建</Button>
        </div>
      </div>
      <div class="table-box template-table">
        <loading :isShow="tableLoading" />
        <Table :columns="columns" :data="tableData" @on-selection-change="onSelectChange" border>
          <template slot-scope="{ row }" slot="action">
            <div>
              <span class="table-btn" @click="openTemplateEdit(row)" v-if="$units.pointAction('content_5_1_2')">编辑</span>
              <span class="table-btn red" @click="delTemplate(row)" v-if="$units.pointAction('content_5_1_3')">删除</span>
            </div>
          </template>
        </Table>
        <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center; margin-top: 20px" />
      </div>
    </div>
    <editCourse ref="editCourse" @reload="searchAjax"></editCourse>
    <!-- 模板使用详情 -->
  </div>
</template>

<script>
import config from './templateList.config';
import editCourse from './components/editCourse';
export default {
  components: {
    editCourse
  },
  data() {
    return config;
  },
  created() {
    if(!this.$units.pointAction('content_5_1_2') && !this.$units.pointAction('content_5_1_3')){
    	this.columns.splice(this.columns.length-1, 1);
    }
    this.searchAjax();
  },
  methods: {
    // 删除模板
    delTemplate(item) {
      this.$notice.inquiry('确定删除分类？').then(() => {
        this.$http({
          url: '/buz/testColumn/del',
          type: 'get',
          data: {
            id: item.id
          },
          apiPermissionCode: ''
        }).then(res => {
          this.$notice.success('操作成功');
          this.searchAjax();
        });
      });
    },
    // 打开模板编辑或新增弹窗
    openTemplateEdit(item) {
      this.$refs.editCourse.open(item || {});
    },
    onSelectChange() {},
    // 获取列表参数
    getParams() {
      const params = Object.assign({}, this.search);
      return params;
    },
    searchAjax() {
      this.pageNum = 1;
      this.getList();
    },
    // 获取列表数据
    getList() {
      const params = this.getParams();
      params.pageNo = this.pageNum;
      params.pageSize = this.pageSize;
      this.tableLoading = true;
      this.$http({
        url: '/buz/testColumn/read/list',
        type: 'post',
        data: params,
        apiPermissionCode: ''
      })
        .then(res => {
          this.tableLoading = false;
          this.tableData = res.data;
          this.total = res.total;
        })
        .catch(e => {
          this.tableLoading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
